import { Currency } from "../../models/shared/formats/Currency";
//Currency
export const currencyFormatByEncodedValue = {
  0: Currency.NONE,
  65536: Currency.ARS,
  // Argentina
  131072: Currency.AUD,
  // Australia
  196608: Currency.BRL,
  // Brazil
  262144: Currency.CAD,
  // Canada
  327680: Currency.CHF,
  // Switzerland
  393216: Currency.CLP,
  // Chile
  458752: Currency.CNY,
  // China
  524288: Currency.CZK,
  // Czech - NOT SUPPORTED IN APP
  589824: Currency.DKK,
  // Denmark
  655360: Currency.EUR,
  // Euro
  720896: Currency.GBP,
  // United Kingdom
  786432: Currency.HKD,
  // Hong Kong
  851968: Currency.ILS,
  // Israel
  917504: Currency.INR,
  // India
  983040: Currency.JPY,
  // Japan
  1048576: Currency.KRW,
  // South Korea
  1114112: Currency.MXN,
  // Mexico
  1179648: Currency.MYR,
  // Malaysia - NOT SUPPORTED IN APP
  1245184: Currency.NOK,
  // Norway
  1310720: Currency.NZD,
  // New Zealand
  1376256: Currency.PHP,
  // Philippines - NOT SUPPORTED IN APP
  1441792: Currency.PLN,
  // Poland - NOT SUPPORTED IN APP
  1507328: Currency.RON,
  // Romania - NOT SUPPORTED IN APP
  1572864: Currency.RUB,
  // Russia
  1638400: Currency.SEK,
  // Sweden
  1703936: Currency.SGD,
  // Singapore
  1769472: Currency.TWD,
  // Taiwan - NOT SUPPORTED IN APP
  1835008: Currency.USD,
  // United States
  1900544: Currency.VND,
  // Vietnam - NOT SUPPORTED IN APP
  1966080: Currency.YTL,
  // Turkey - NOT SUPPORTED IN APP
  2031616: Currency.ZAR // South Africa
};

export const encodedValueByCurrencyFormat = {
  [Currency.ARS]: 65536,
  // Argentina
  [Currency.AUD]: 131072,
  // Australia
  [Currency.BRL]: 196608,
  // Brazil
  [Currency.CAD]: 262144,
  // Canada
  [Currency.CHF]: 327680,
  // Switzerland
  [Currency.CLP]: 393216,
  // Chile
  [Currency.CNY]: 458752,
  // China
  [Currency.CZK]: 524288,
  // Czech - NOT SUPPORTED IN APP
  [Currency.DKK]: 589824,
  // Denmark
  [Currency.EUR]: 655360,
  // Euro
  [Currency.GBP]: 720896,
  // United Kingdom
  [Currency.HKD]: 786432,
  // Hong Kong
  [Currency.ILS]: 851968,
  // Israel
  [Currency.INR]: 917504,
  // India
  [Currency.JPY]: 983040,
  // Japan
  [Currency.KRW]: 1048576,
  // South Korea
  [Currency.MXN]: 1114112,
  // Mexico
  [Currency.MYR]: 1179648,
  // Malaysia - NOT SUPPORTED IN APP
  [Currency.NOK]: 1245184,
  // Norway
  [Currency.NZD]: 1310720,
  // New Zealand
  [Currency.PHP]: 1376256,
  // Philippines - NOT SUPPORTED IN APP
  [Currency.PLN]: 1441792,
  // Poland - NOT SUPPORTED IN APP
  [Currency.RON]: 1507328,
  // Romania - NOT SUPPORTED IN APP
  [Currency.RUB]: 1572864,
  // Russia
  [Currency.SEK]: 1638400,
  // Sweden
  [Currency.SGD]: 1703936,
  // Singapore
  [Currency.TWD]: 1769472,
  // Taiwan - NOT SUPPORTED IN APP
  [Currency.USD]: 1835008,
  // United States
  [Currency.VND]: 1900544,
  // Vietnam - NOT SUPPORTED IN APP
  [Currency.YTL]: 1966080,
  // Turkey - NOT SUPPORTED IN APP
  [Currency.ZAR]: 2031616,
  // South Africa
  [Currency.NONE]: 0
};

// Encode / Decode functions
export const decodeCurrencyFormat = _ref => {
  let {
    currency
  } = _ref;
  return {
    currency: currencyFormatByEncodedValue[currency] || Currency.NONE
  };
};
export const encodeCurrencyFormat = decodedFormat => ({
  currency: encodedValueByCurrencyFormat[decodedFormat.currency]
});
//# sourceMappingURL=Currency.js.map